import * as Actions from '../../actions/register/index';

const initialState = 0;

const steps = function (state = initialState, action) {
    switch ( action.type )
    {
        case Actions.SET_STEP:
        {
            return action.payload;
        }

        case Actions.REMOVE_STEP:
        {
            return initialState;
        }
        
        default:
        {
            return state;
        }
    }
}

export default steps;